import * as React from 'react'

import {
    Stack,
    Box,
    Button
} from '@mui/material'
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom'

import {HashLink as Link } from "react-router-hash-link";

import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import LocationCityIcon from '@mui/icons-material/LocationCity';


import { InformationComponent, InformationContent, IconsDiv, Logo, LogoDiv, InformationText, SearchDiv, TextContent, TextLogo, TextComponent } from './styles';

import LogoIcon from '../../../assets/images/logo/logoSetra.png'
import Icon1 from '../../../assets/images/icons/ICONES-PEQUENOS-v2.png'
import Icon2 from '../../../assets/images/icons/ICONES-PEQUENOS-2-v2.png'

interface TopHeaderProps {
    reference?: any;
    title?: any;
}

const InformationFooter: React.FC<TopHeaderProps> = ({ reference, title }) => {

    const matches = useMediaQuery('(max-width:800px)');

    return (
        <InformationComponent>
            <InformationContent>
                <InformationText>
                    <TextComponent>
                        <TextLogo>
                            {/* <Logo src={Icon1} style={{ width: matches ? "60px" : "80px" , height: matches ? "60px" : "80px" }}/> */}
                            <PhoneInTalkIcon style={{ width: matches ? "50px" : "70px" , height: matches ? "50px" : "70px", color: "white" }}/>
                        </TextLogo>
                        <TextContent>
                            <h1>(31) 3248-7300</h1>
                            <p>Seg-Sex: 8:00-16:00</p>      
                        </TextContent>
                    </TextComponent>
                    <TextComponent>
                        <TextLogo>
                            {/* <Logo src={Icon2} style={{ width: matches ? "60px" : "80px" , height: matches ? "60px" : "80px" }}/> */}
                            <LocationCityIcon style={{ width: matches ? "50px" : "70px" , height: matches ? "50px" : "70px", color: "white"  }}/>
                        </TextLogo>
                        <TextContent>
                            <h1>Belo Horizonte - MG</h1>
                            <p>R. Aquiles Lobo, 504 - Floresta</p>      
                        </TextContent>
                    </TextComponent>
                    
              
                </InformationText>
            </InformationContent>
        </InformationComponent>
    );
}

export { InformationFooter }